export function BasicLayout(props) {
    const {children} = props;
  return (
    <div>{children}</div>
  )
}
